import { compose, has, last } from 'ramda';
import { isFunction } from 'ramda-extension';

const ACTION = 'ACTION';
const FULL_URL = 'FULL_URL';
const MAILTO = 'MAILTO';
const HASH_LINK = 'HASH_LINK';
const RELATIVE_URL = 'RELATIVE_URL';
const CALLBACK = 'CALLBACK';

export const TYPES = {
  ACTION,
  FULL_URL,
  MAILTO,
  HASH_LINK,
  RELATIVE_URL,
  CALLBACK,
};

const linkTypes = [
  [(to) => to?.startsWith?.('mailto'), MAILTO],
  [(to) => to?.startsWith?.('http'), FULL_URL],
  [(to) => to?.startsWith?.('#'), HASH_LINK],
  [isFunction, CALLBACK],
  [has('type'), ACTION],
  [() => true, RELATIVE_URL],
];

export const linkType = compose(last, (to) =>
  linkTypes.find(([matcher]) => matcher(to))
);
